export const DATA_TYPES_FOR_DATA_EXTRACTION = ["collected_data", "calculated_data"] as const;
export type ExtractedQuestionType = (typeof DATA_TYPES_FOR_DATA_EXTRACTION)[number];

export const PHASE_TYPES = ["collected_data", "calculated_data", "transmitted_data"] as const;
export type PhaseType = (typeof PHASE_TYPES)[number];

export const DATA_FORMAT_TYPES = [
  "text",
  "integer_range",
  "decimal_range",
  "percentage",
  "boolean",
  "scale",
  "mcq",
  "date",
  "object", // Pour données structurées complexes
] as const;
export type DataFormatType = (typeof DATA_FORMAT_TYPES)[number];

export const OPERATORS = ["above", "below", "equals", "not_equals", "between", "contains", "not_contains"] as const;
export type OperatorType = (typeof OPERATORS)[number];

export const CONDITION_VALIDATION_TYPES = ["consecutive", "total", "percentage"] as const;
export type ConditionValidationType = (typeof CONDITION_VALIDATION_TYPES)[number];

export const DELAY_UNITS = ["days", "weeks", "months"] as const;
export type DelayUnitType = (typeof DELAY_UNITS)[number];

export const EXCEPTION_ACTIONS = ["delay", "skip", "repeat"] as const;
export type ExceptionActionType = (typeof EXCEPTION_ACTIONS)[number];

export const DATA_CONDITION_MODES = ["data_condition", "time_condition"] as const;
export type DataConditionModeType = (typeof DATA_CONDITION_MODES)[number];

export const ALERT_SEVERITIES = ["low", "medium", "high", "critical"] as const;
export type AlertSeverityType = (typeof ALERT_SEVERITIES)[number];

export const ALERT_ACTIONS = ["email", "sms", "phone", "emergency"] as const;
export type AlertActionType = (typeof ALERT_ACTIONS)[number];

export const ALERT_MODES = ["data_condition", "time_condition", "no_response"] as const;
export type AlertModeType = (typeof ALERT_MODES)[number];

export const MESSAGE_FREQUENCIES = ["once", "last_call", "each_call"] as const;
export type MessageFrequencyType = (typeof MESSAGE_FREQUENCIES)[number];

export const SCHEDULE_REFERENCE_POINTS = [
  "treatment_start",
  "hospital_discharge",
  "surgery_date",
  "phase_start",
] as const;
export type ScheduleReferencePointType = (typeof SCHEDULE_REFERENCE_POINTS)[number];

export const FREQUENCY_CONFIG_TYPES = ["daily", "weekly", "monthly", "custom", "scheduled"] as const;
export type FrequencyConfigurationType = (typeof FREQUENCY_CONFIG_TYPES)[number];

export const MONTHLY_CONFIG_TYPES = ["specific_day", "last_day"] as const;
export type MonthlyConfigType = (typeof MONTHLY_CONFIG_TYPES)[number];

export const WORKFLOW_STATUS_TYPES = ["draft", "released", "archived"] as const;
export const AGENT_STATUS_TYPES = ["draft", "released", "deployed", "active", "archived"] as const;
export type WorkflowStatusType = (typeof WORKFLOW_STATUS_TYPES)[number];
export type AgentStatusType = (typeof AGENT_STATUS_TYPES)[number];

export const PUBLICATION_STATUS_TYPES = [
  "not_published",
  "pending_review",
  "approved",
  "rejected",
  "suspended",
] as const;
export type PublicationStatusType = (typeof PUBLICATION_STATUS_TYPES)[number];

export const PHASE_HISTORY_STATUS_TYPES = [
  "pending",
  "completed",
  "paused",
  "cancelled",
  "skipped",
  "in_progress",
] as const;
export type PhaseHistoryStatusType = (typeof PHASE_HISTORY_STATUS_TYPES)[number];

export const FOLLOW_UP_STATUS_TYPES = ["active", "paused", "completed", "cancelled"] as const;
export type FollowUpStatusType = (typeof FOLLOW_UP_STATUS_TYPES)[number];
